import React from 'react';
import AssessmentTool from './AssessmentTool';
import { aiRmfMeta, aiRmfQuestions, computeAiRmfResult } from '../config/nistAiRmfConfig';

const NistAiRmfAssessmentPage = () => (
  <AssessmentTool
    meta={aiRmfMeta}
    questions={aiRmfQuestions}
    computeResult={computeAiRmfResult}
  />
);

export default NistAiRmfAssessmentPage;
